import type { AsrCreateTranscriptionRequest } from '../api/types';
import type { TPipelineDraft } from '../types/TPipelineDraft';

export const buildPipelineSelectionRequest = (
  draft: TPipelineDraft,
): Pick<AsrCreateTranscriptionRequest, 'normalizers' | 'quality_checkers'> => ({
  ...(draft.normalizers ? { normalizers: draft.normalizers } : {}),
  ...(draft.qualityCheckers ? { quality_checkers: draft.qualityCheckers } : {}),
});
